import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {State} from '../../store/reducer/mitarbeiterverwaltung.reducer';
import {Observable} from 'rxjs';
import {BrancheItem} from '../../branche.model';
import {editFirmaStart} from '../../store/actions/firma-edit.actions';
import {loadBranchenStart} from '../../store/actions/branche.actions';
import {loadFirmaZeitenStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getFirmaZeiten.actions';
import {FirmaZeitItem} from '@src/app/pages/Mitarbeiterverwaltung/firmaZeit.model';
import {MitarbeiterFormdialogComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/mitarbeiter-form-dialog/mitarbeiter-formdialog.component';
import {FirmaZeitFormdialogComponent} from '@src/app/pages/Mitarbeiterverwaltung/components/firmazeiten-form-dialog/firmazeiten-formdialog.component';
import {addFirmaZeitFailed, addFirmaZeitStart} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/firmaZeiten-add.actions';

export interface DialogData{
  title: string;
  submitButtonLabel: string;
  cancelButtonLabel: string;
  id: number;
  name: string;
  email: string;
  telefon: string;
  ort: string;
  plz: string;
  str1: string;
  str2: string;
  branche: string;
  arbsol: number;
}

@Component({
  selector: 'app-firma-formdialog',
  templateUrl: './firma-formdialog.component.html',
  styleUrls: ['./firma-formdialog.component.scss']
})


export class FirmaFormdialogComponent implements OnInit {

  public $branchen: Observable<BrancheItem[]>;
  public $firmaZeiten: Observable<FirmaZeitItem[]>;


  constructor(public dialogRef: MatDialogRef<FirmaFormdialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private store: Store<{ mitarbeiterverwaltung: State }>,
              public dialog: MatDialog,
              )
  {
    dialogRef.disableClose = true;
    this.$branchen = store.pipe(select((state) => state.mitarbeiterverwaltung.branchen.items));
    this.$firmaZeiten = store.pipe(select((state) => state.mitarbeiterverwaltung.firmaZeiten));
    this.firmaForm.patchValue({
      name: data.name,
      email: data.email,
      telefon: data.telefon,
      arbsol: data.arbsol?.toFixed(2),
      branche: data.branche,
      ort: data.ort,
      plz: data.plz,
      str1: data.str1,
      str2: data.str2,
      id: data.id
    });
  }

  public firmaForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(255), Validators.pattern('[a-zA-Z áéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ]*')]),
    email: new FormControl('' , [Validators.maxLength(255), Validators.pattern('^[a-záéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
    telefon: new FormControl('', [Validators.maxLength(255), Validators.pattern('^[0-9.]*$')] ),
    ort: new FormControl('', [Validators.required , Validators.minLength(3), Validators.maxLength(255), Validators.pattern('[a-zA-Z áéíóúàèìòùâêîôûäëïöüñõçßáéíóúàèìòùâêîôûäëïöüñõçßÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÕÇ]*')]),
    plz: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.min(1000), Validators.maxLength(255) ]),
    str1: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(255)]),
    str2: new FormControl('' , [Validators.maxLength(255)]),
    arbsol: new FormControl('', [Validators.required, Validators.maxLength(255), Validators.pattern('^[0-9.]*$')]),
    branche: new FormControl(''),
  });

  public getErrorMessage(formField: string): string {
    const formControl = this.firmaForm.get(formField);
    if ( formControl.hasError('required')){
      return `pages.mitarbeiterverwaltung.firmaDialog.err.${formField}.pflichtfeld`;
    }
    else if ( formControl.hasError('minlength')){
      return `pages.mitarbeiterverwaltung.firmaDialog.err.${formField}.minlength`;
    }
    else if ( formControl.hasError('maxlength')){
      return `pages.mitarbeiterverwaltung.firmaDialog.err.${formField}.maxlength`;
    }
    else if ( formControl.hasError('min')){
      return `pages.mitarbeiterverwaltung.firmaDialog.err.${formField}.min`;
    }
    else if ( formControl.hasError('pattern')){
      return `pages.mitarbeiterverwaltung.firmaDialog.err.${formField}.pattern`;
    }
    return 'pages.mitarbeiterverwaltung.firmaDialog.err.generic';
  }

  public handleSubmitClick(): void{
    const item = this.firmaForm.value;
    this.store.dispatch(editFirmaStart({item: {...item, id: this.data.id}}));
    this.dialogRef.close(true);
  }

  public handleCancelClick(): void{
    this.dialogRef.close(true);
  }

  ngOnInit(): void {
    this.store.dispatch(loadBranchenStart());
    this.store.dispatch(loadFirmaZeitenStart());

  }

  public addFirmaZeit(): void{
    this.store.dispatch(addFirmaZeitStart());
    const dialogRef = this.dialog.open(FirmaZeitFormdialogComponent, {
      data: {
        title: 'pages.mitarbeiterverwaltung.firmaDialog.firmaZeitenh',
        submitButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.submitButtonLabel',
        cancelButtonLabel: 'pages.mitarbeiterverwaltung.editpersonalien.cancelButtonLabel',
      }

    });
    dialogRef.afterClosed().subscribe();
  }
}
